import { render, staticRenderFns } from "./file-menu.vue?vue&type=template&id=6a2d49e0&"
import script from "./file-menu.vue?vue&type=script&lang=js&"
export * from "./file-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports